<template>
  <div>
    <b-modal visible
             size="md"
             centered
             no-close-on-backdrop
             no-close-on-esc
             no-close
             hide-header-close
             header-bg-variant="secondary"
             header-text-variant="light"
             hide-footer>
      <template slot="modal-header">
        <div class="row ">
          <div class="col">
            <h5 class="ProtocoloForm--header">
              Novo andamento
            </h5>
          </div>
        </div>
      </template>
      <div class="row">
        <div class="col">
          <label for="observacao_log"
                 class="label">
            Observação<span class="text-danger">*</span>
          </label>
          <textarea id="observacao_log"
                    v-model="log.observacao"
                    v-validate="'required|max: 255'"
                    class="form-control form-control-sm"
                    name="observacao_log"
                    placeholder="Descrição do andamento..."
                    :class="{ 'is-invalid text-danger': errors.has('observacao_log') }"
                    cols="30"
                    rows="5" />
          <small v-if="errors.has('observacao_log')"
                 class="text-danger">
            {{ errors.first('observacao_log') }}
          </small>
        </div>
      </div>
      <hr class="hr-secondary">
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-sm btn-outline-secondary"
                  @click="$emit('onCloseModal')">
            Voltar
          </button>
          <button class="ml-2 btn btn-sm btn-secondary"
                  @click="save()">
            {{ Object.values(this.propLog).length > 0 ? 'Editar' : 'Salvar' }}
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: "ProtocoloLogForm",
    props: {
      propLog: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        log: {
          observacao: null,
          protocolo_id: null
        }
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        if (Object.values(this.propLog).length > 0) {
          this.log = { ...this.propLog }
        }
      },
      async save () {
        const status = await this.$validator.validate()

        if (status) {
          this.log.protocolo_id = this.$route.params.id
          this.$emit('onSaveLog', this.log)
        }
      }
    }
  }
</script>

<style scoped>

</style>
